import { StripeAccountRequirementsState } from "@/services/interfaces/IBillingSettingsService";

export const normalizeCurrency = (v?: string | null) => {
  const normalized = v?.trim().toUpperCase();

  return normalized && normalized.length > 0 ? normalized : "EUR";
};

export const buildUrl = (path: string) => `${window.location.origin}${path}`;

export const goTo = (url: string) => {
  // assign is better for external redirects
  window.location.assign(url);
};

/**
 * Compute when user should be prompted to continue onboarding / fix issues.
 * It's more robust than relying only on status !== "ACTIVE".
 */
export const needsStripeAction = (s: StripeAccountRequirementsState) => {
  const hasReqErrors = Boolean(s.requirementErrors?.length);
  const hasOutstanding = Boolean(s.outstandingRequirements?.length);
  const notReady =
    !s.onboardingComplete || !s.chargesEnabled || !s.payoutsEnabled;
  return (
    notReady ||
    Boolean(s.disabledReason) ||
    hasReqErrors ||
    hasOutstanding ||
    s.status !== "ACTIVE"
  );
};
